import { IconFileDescription, IconUpload, IconTrash, IconEdit } from '@tabler/icons-react';
import { NavigateFunction } from 'react-router-dom';
import { AfaTableColumn } from '../components/ui/AfaTable/AfaTable';
import { AfaAnchor } from '../components/ui/AfaAnchor';
import { AfaMenu } from '../components/ui/AfaMenu';
import moment from 'moment';

interface TramesesTableHandlers {
  onCancelTramesa: (tramesaId: string) => void;
  onDeleteDraft: (tramesaId: string) => void;
  userMail: any;
}

/**
 * Configuración de columnas para la tabla de Trameses
 * Esta función retorna la configuración completa de las columnas de la AfaTable
 * 
 * @param navigate - Función de navegación de React Router
 * @param handlers - Handlers para acciones de la tabla
 * @returns Array de configuración de columnas para AfaTable
 */
export function getTramesesColumns(
  navigate: NavigateFunction,
  handlers: TramesesTableHandlers,
  userMail: any
): AfaTableColumn[] {
  return [
    {
      key: 'guid',
      title: 'ID',
      type: 'text',
      width: 200,
      render: (value, row) => (
        <AfaAnchor
          href="#"
          size="md"
          onClick={e => {
            e.preventDefault();
            navigate(`/trameses/detall/${row.id}`);
          }}
        >
          {value}
        </AfaAnchor>
      )
    },
    {
      key: 'filial.lookupValue',
      title: 'Filial',
      type: 'text',
      width: 50,
    },
    {
      key: 'tramesaType.lookupValue',
      title: 'Tipus',
      type: 'text',
      width: 300,
    },
    {
      key: 'registerDate',
      title: 'Data de presentació',
      type: 'text',
      width: 100,
      render: (value) => {
        const date = moment(value);
        if (!date.isValid() || date.year() <= 1900) {
          return null;
        }
        return date.format('YYYY-MM-DD HH:mm');
      }
    },
    {
      key: 'state',
      title: 'Estat',
      type: 'badge',
      width: 100,
      badgeConfig: {
        colorMap: {
          'Pendent rebre documentació': 'orange',
          'Cancel·lat entitat': 'lilac',
          'Rebutjat AFA': 'red',
          'Tramès': 'green',
          'Esborrany': 'blue'
        }
      }
    },
    {
      key: 'createdBy.lookupValue',
      title: 'Creada per',
      type: 'text',
      width: 100,
    },
    {
      key: 'accions',
      title: '',
      type: 'menu',
      width: 40,
      render: (value, row) => {
        const menuItems = [];

        menuItems.push({
          label: 'Veure Detall',
          icon: <IconFileDescription />,
          onClick: () => navigate(`/trameses/detall/${row.id}`)
        });
        if (row.state == 'Esborrany') {
          menuItems.push(
            {
              label: 'Editar',
              icon: <IconEdit />,
              onClick: () => navigate(`/trameses/editar/${row.id}`)
            })
          if (row.createdBy != null && row.createdBy.lookupId != -1 && row.createdBy.lookupValue === userMail.user.titulo) {
            menuItems.push({
              label: 'Esborrar',
              icon: <IconTrash />,
              color: 'red',
              onClick: () => handlers.onDeleteDraft(row.id)
            });
          }
        }
        else {
          switch (row.fase) {
            case 'Validació i Anàlisi':
              menuItems.push(
                {
                  label: 'Cancel·lar',
                  icon: <IconTrash />,
                  color: 'red',
                  onClick: () => handlers.onCancelTramesa(row.id)
                }
              );
              break;
            case 'Pendent rebre documentació':
              menuItems.push(
                {
                  label: 'Enviar documentació',
                  icon: <IconUpload />,
                  onClick: () => navigate(`/trameses/detall/${row.id}?sendDocs=true`)
                }
              );
              break;

            default:
              break;
          }
        }

        return <AfaMenu variant="filled" items={menuItems} />;
      }
    }

  ];
}
